module.exports = __webpack_public_path__ + "static/media/A1.fa37f675.jpg";